import Mustache from 'mustache'

export default {
  name: 'share-icons',
  props: {
    pdfSrc: {
      type: String
    },
    title: {
      type: String,
      default: ''
    },
    body: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    isMounted: false
  }),
  computed: {
    scope() {
      return {
        isMounted: this.isMounted
      }
    },
    options() {
      return {
        href: window.location.href,
        title: this.title,
        body: this.body
      }
    },
    shareConfig() {
      return {
        email: 'mailto:?subject={{title}}&body={{body}}\n{{href}}',
        twitter: 'https://twitter.com/share?text={{title}}\n{{body}}&url={{href}}',
        facebook: 'http://www.facebook.com/share.php?u={{href}}'
      }
    }
  },
  async mounted() {
    this.$el.querySelectorAll('ul li').forEach(element => {
      const type = element.id.replace('-share', '')
      if (this.shareConfig[type]) {
        const anchor = element.querySelector('a')
        anchor.href = Mustache.render(this.shareConfig[type], this.options)
      } else if (element.id === 'download-pdf') {
        const anchor = element.querySelector('a')
        if (this.noHref(anchor.href) && this.pdfSrc) {
          anchor.href = this.pdfSrc
        } else if (this.noHref(anchor.href)) {
          element.remove()
        }
      } else {
        element.remove()
      }
    });
    this.isMounted = true
  },
  methods: {
    noHref(href) {
      return !href || href === '#' || href === window.location.href
    }
  },
  render() {
    return this.$scopedSlots.default(this.scope)
  }
}